<template>
<div id="sec_query">  
     <div class="btn-form-admin">
        <b-btn variant="outline-secondary" @click="toAdmin()" > 	&#8592; Regresar al administrador</b-btn>
                                    
     </div>
     <h1>Panel de configuración de Query</h1>
     <p>sum completados - sum m3</p>
      <div class="msg_alert" v-if="!validateDia()">
          <p>Editar Query deshabilitado, solo podras realizar cambios los lunes a partir de las 11 am al viernes a las antes de las 2 pm.</p>
      </div>
   
<div >
      

        <b-row class="pila_query" id="pilas-form-admin">  
           
             <b-col  class="bg-white  col-12  adminPila" >   
                <b-row>
                    <b-col class="">
                       
                        <div>
                            
                              <form
                                @submit.prevent="
                                    editarQuery(
                                        dataquery.query,
                                        cambios
                                    )
                                "
                                >
                                

                                <div class="row mx-0 row-one">
                                    <div class="">
                                    <label class="labelQueryTA" for="QueryTA" >Query</label >
                                    <b-form-textarea v-model="dataquery.query" id="QueryTA" :disabled="!validateDia()" />
                                    </div>
                                </div>
                            
                                 <div class="form_cambios">
                                     <label for="cambiosTA">Escribe una breve descripción de los cambios que estas realizando</label>
                                      <textarea v-model="cambios" id="cambiosTA" name="cambiosTA"  cols="30" rows="5" required :disabled="!validateDia()"></textarea>
                                 </div>  

                                <div class="btn-form-query">
                                    <b-btn
                                    variant="outline-secondary"
                                    class="editar-modal "
                                    type="submit" :disabled="!validateDia()">GUARDAR</b-btn>
                                    
                                </div>
                                </form>
    <div v-if="status !=''">
          <div v-if="status=='error'">
            <p class="msg_error">{{msg}}</p>
          </div>
          <div v-else>
             <p class="msg_success">{{msg}}</p>
          </div>
      </div>
                                <!--  Tabla -->
                                <div id="historial_querys">
                                    <h3>HISTORIAL DE VERSIONES</h3>
                                    <p>Cuando guardas un cambio en la query automaticamente pasará a ser la query activa y se guardara como una nueva query con el fin de poder volver a la versión anterior.</p>
                                    <p>¿Algo salio mal? <span class="text_grey">Puedes volver a la versión anterior dando click a Activar.</span> </p>
                                    <p>Dando click en mostrar se desplegará un modal donde puedes ver los cambios que se realizáron en esa versión.</p>
                                    <p>Es recomendable eliminar aquellas querys que tengan algun error de cálculo o que ya no seran utilizadas.</p>
                                </div>
                                <div class="Tabla">
                                   <div class="tabla_yellow">
                                            <div class="ty_text">
                                                <p id="elim_text1">Cambios</p>
                                                <p id="elim_text2">Fecha</p>
                                                <p id="elim_text3">Acualizacion por</p>
                                                <p id="elim_text4">Activa</p>
                                                <p id="elim_text5">Activar</p>
                                                <p id="elim_text6">Eliminar</p>
                                            </div>
                                        </div>
                                    <div class="tabla_content">
                                        <div class="div_content" v-for="(query, key) in allQuerys " :key="key">    
                                            <div class="registros">
                                                <div v-if="query.activa=='si'" class="square1" style="background-color: rgb(0, 194, 144);"></div>
                                                <div v-else class="square1" style="background-color: rgb(231 54 41);"></div>
                                                <p id="t1" @click="mostrarCambios(query.cambios)" v-b-modal.modal-cambios variant="outline-secondary text-white">mostrar</p>
                                                <p id="t2">{{query.update_at}}</p>
                                                <p id="t3"> <template v-if="query.updateby == 'Admin Dev APP FANOSA-15177117'">Erik Glz. - Legrafica.</template> <template v-else>{{query.updateby}}</template></p>
                                                <p id="t4">{{query.activa}}</p>
                                                <p @click="setKey(query.id)" v-b-modal.modal-activar variant="outline-secondary text-white" v-if="query.activa=='no'" class="activar">Activar</p>
                                                 <p v-else class="activa">Activa</p>
                                                <p v-if="query.activa=='no'" @click="setKey(query.id)" v-b-modal.modal-logout variant="outline-secondary text-white" id="equis">&#10006;</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                          </div>

                    </b-col>


                    <div>

                        <!-- _____BLOQUE 0_____ -->
                          <div class="headerBlq">
                              <p>¿Cuando actualizar la query?</p>
                          </div>
                         <div class="bloque0">
                              
                            <p>La actualización del Query estará disponible solo a partir del día lunes a las 11:00 am al  
                                día viernes antes de las 2 pm. (Horario de Hermosillo).  Con el fin de evitar cualquier inconveniente y 
                                dar oportunidad a revisión.</p>
                        </div>

                           <!-- _____BLOQUE 5_____ -->
                    <div class="headerBlq">
                        <p>IMPORTANTE</p>
                    </div>
                    <div class="bloque5">
                         <p>NO MODIFICAR '[no-eliminar]' NI NADA DESPUES DE LA ‘<span class="text_red">UNION ALL</span>’</p>
<pre><b>Porque es importante no modificar el   =  '[no-eliminar]'</b>
Originalmente en la query se indica una fecha,  algo como la siguiente línea
and to_date(jobs.scheduled_completion_date) <b>>= '01/ENE/2020'</b>   esta fecha debe ser
dinámica para la app, de tal forma que el <b>>='01/ENE/2020'</b>  se debe sustituir por  <b>=  '[no-
eliminar]'</b>  , de esta manera la app entiende que en esta parte debe ir la fecha que cambiara
día con día.</pre>
                        </div>


                 <div class="headerBlq">
                        <p>Hora de actualización de producción</p>
                    </div>
                    <div class="bloque4">
                        <p>Con el fin de agilizar el tiempo de carga de la App, la Query actualmente no se ejecuta en tiempo real, es decir, anteriormente cuando entrabas 
                            a un departamento que hacía uso de esta Query para obtener la producción, esta se ejecutaba y se obtenía la información, pero con estos cambios 
                            el tiempo de respuesta se elevó bastante lo que ocasionaba que tardara más la App en mostrar la información, de tal forma que ahora la Query  
                            se ejecutara una vez cada hora con el fin de guardar la producción y con esto agilizar la respuesta. A continuación se muestra una tabla y el 
                            minuto en el que se actualiza la producción de la ciudad.  Ejemplo JUAREZ se actualiza cada minuto 23 de cada hora: 9:23, 10:23, 11:23.... 
                        </p>
                       
                        <div class="div_table">
                            <table>
                               
                                <tr>
                                    <td>Dep. Preexpansión</td>
                                     <td>22</td>
                                </tr>
                                <tr>
                                    <td>JUAREZ</td>
                                     <td>23</td>
                                </tr>
                                <tr>
                                    <td>CANCUN</td>
                                     <td>24</td>
                                </tr>
                                <tr>
                                    <td>CIUDAD_DE_MEXICO</td>
                                      <td>25</td>
                                </tr>
                                <tr>
                                    <td>CULIACAN</td>
                                    <td>26</td>
                                </tr>
                                <tr>
                                    <td>GUADALAJARA</td>
                                     <td>27</td>
                                </tr>
                                <tr>
                                    <td>HERMOSILLO</td>
                                     <td>28</td>
                                </tr>
                                
                                <tr>
                                    <td>LA_PAZ</td>
                                      <td>29</td>
                                </tr>
                                <tr>
                                    <td>MERIDA</td>
                                      <td>30</td>
                                </tr>
                                <tr>
                                    <td>MEXICALI</td>
                                     <td>31</td>
                                </tr>
                                <tr>
                                    <td>MONTERREY</td>
                                     <td>32</td>
                                </tr>
                                <tr>
                                    <td>NOGALES</td>
                                     <td>33</td>
                                </tr>
                                <tr>
                                    <td>QUERETARO</td>
                                     <td>34</td>
                                </tr>
                                <tr>
                                    <td>TIJUANA</td>
                                     <td>35</td>
                                </tr>
                                <tr>
                                    <td>VERACRUZ</td>
                                     <td>36</td>
                                </tr>
                                <tr>
                                    <td>VILLAHERMOSA</td>
                                     <td>37</td>
                                </tr>
                            </table>
                        </div>
                    </div>


                        

                        <!-- _____BLOQUE 1_____ -->                       
                        <div class="headerBlq">
                            <p>NOTAS</p>
                        </div>
                        <div class="bloque1">                        
                            <p>M3 = METROS CUBICOS o METROS CUADRADOS</p>
                            <p>COMPLEADOS= KGS, PLACAS, HIELERAS, BLOCK PIEZAS</p>
                            <p>‘--‘ Significa que lo que muestra está documentado, no aplica en el Query solo es una Nota</p>
                        </div>


                     

                        <!-- _____BLOQUE 2_____ -->
                    <div class="headerBlq">
                         <p>Agregar línea o cálculo nuevo</p>
                    </div>
                    <div class="bloque2">
                        <p class="text_title">Agregar una id de línea a una Area</p>
                        <p>Colocamos el id “2221” que deseamos agregar</p>
                        <p><span class="text_blue">WHEN</span> jobs.line_id <span class="text_blue">in (</span>1003, 1004, 2404, 2405, 2417, 2537, 2435, 2221<span class="text_blue">) THEN</span> <span class="text_red">'EMPAQUE CORTADO'</span></p>
                        <p class="text_title">Agregar un cálculo condicional especial para completados</p>
                        <pre>    (<span class="text_blue">CASE
    WHEN</span>
( jobs.organization_id = 511 <span class="text_blue">or</span> jobs.organization_id = 583<span class="text_blue">) and (</span>jobs.line_id <span class="text_blue">in (</span>2488<span class="text_blue">,</span> 2489, 2418,
  2419, 2420<span class="text_blue">)) THEN</span> COMPLETADOS/2.928
   --Condicion agregada
    <span class="text_blue">WHEN</span> jobs.organization_id = 283 <span class="text_blue">and</span> jobs.line_id <span class="text_blue">in (</span>2403<span class="text_blue">) THEN (</span>COMPLETADOS/2.928<span class="text_blue">)</span>
    <span class="text_blue">+ (</span>tot_M3/5.32<span class="text_blue">)</span>
    WHEN ( jobs.organization_id = 283) and (jobs.line_id in (2488)) THEN ((COMPLETADOS/2.928)
    <span class="text_blue">+ (</span>tot_M3/7.32<span class="text_blue">))</span>

     <span class="text_blue">else</span> COMPLETADOS <span class="text_blue">END)</span> COMPLEADOS</pre>
                        <p id="b1_t6">El siguiente calculo condicional agregado significa que cuando la organización sea 283 = Culiacán,
y el Id de línea 2403. <b>Completados</b> = (completados/2.928) + (M3/7.32). </p>
                        <p id="b1_t7">Nota: recuerda no repetir condicionales para el mismo id y la misma organización, tomara
la primera condición que este en el Query</p>
                    </div>


                        <!-- _____BLOQUE 3_____ -->
                    <div class="headerBlq">
                         <p>Agregar cálculo condicional</p>
                    </div>
                    <div class="bloque3">
                        <p id="b3_titulo" class="text_title">cálculo condicional especial para M3</p>
                        <pre><span class="text_blue">, (
 CASE</span>
<span class="text_green">WHEN jobs.line_id in (2543) AND jobs.organization_id = 510 THEN
(to_number(nvl(tot_M3, 0)) * 2)</span>

<span class="text_blue">WHEN</span> jobs.line_id <span class="text_blue">in (</span>2538, 2542<span class="text_blue">) AND</span> jobs.organization_id = 508
<span class="text_blue">THEN (to_number(nvl(</span>tot_M3, 0<span class="text_blue">))</span> * 2<span class="text_blue">)</span> <span class="text_green">-- Veracruz CORTE LINEA 2538, 2542 SE MULTIPLICA * 2</span>

<span class="text_blue">WHEN</span> jobs.line_id <span class="text_blue">in (</span>2544<span class="text_blue">) AND</span> jobs.organization_id <span class="text_blue">=</span> 509
<span class="text_blue">THEN (to_number(nvl(</span>tot_M3, 0<span class="text_blue">))</span> * 3<span class="text_blue">)</span>

<span class="text_blue">WHEN (</span> jobs.organization_id <span class="text_blue">=</span> 203<span class="text_blue">) and (</span>jobs.line_id <span class="text_blue">in (</span>2435<span class="text_blue">))</span>
<span class="text_blue">THEN</span> COMPLETADOS

<span class="text_blue">ELSE</span> tot_M3 <span class="text_blue">END)</span> M3</pre>
                        <p id="b3_text3">El siguiente calculo agregado significa que cuando la organización sea 510 = Cancún, y el Id de línea 2543.</p>
                        <p id="b3_text3"><b>M3</b> = (tot_M3*3). </p>
                        <p id="b3_text3">Validación para evitar error = to_number(nvl(valor_numerico, en_caso_de_estar_vacio)</p>
                        <p id="b3_text5">Nota: recuerda no repetir condicionales para el mismo id y la misma organización, tomara la primera condición que
este en el Query</p>
                    </div>


                        <!-- _____BLOQUE 4_____ -->
                    <div class="headerBlq">
                        <p>Organizaciones y sus ID</p>
                    </div>
                    <div class="bloque4">
                       
                        <div class="div_table">
                            <table>
                               
                                <tr>
                                    <td>CANCUN</td>
                                     <td>510</td>
                                </tr>
                                <tr>
                                    <td>CIUDAD_DE_MEXICO</td>
                                      <td>592</td>
                                </tr>
                                <tr>
                                    <td>CULIACAN</td>
                                    <td>283</td>
                                </tr>
                                <tr>
                                    <td>GUADALAJARA</td>
                                     <td>467</td>
                                </tr>
                                <tr>
                                    <td>HERMOSILLO</td>
                                     <td>184</td>
                                </tr>
                                <tr>
                                    <td>JUAREZ</td>
                                     <td>343</td>
                                </tr>
                                <tr>
                                    <td>LA_PAZ</td>
                                      <td>243</td>
                                </tr>
                                <tr>
                                    <td>MERIDA</td>
                                      <td>509</td>
                                </tr>
                                <tr>
                                    <td>MEXICALI</td>
                                     <td>323</td>
                                </tr>
                                <tr>
                                    <td>MONTERREY</td>
                                     <td>383</td>
                                </tr>
                                <tr>
                                    <td>NOGALES</td>
                                     <td>203</td>
                                </tr>
                                <tr>
                                    <td>QUERETARO</td>
                                     <td>471</td>
                                </tr>
                                <tr>
                                    <td>TIJUANA</td>
                                     <td>303</td>
                                </tr>
                                <tr>
                                    <td>VERACRUZ</td>
                                     <td>508</td>
                                </tr>
                                <tr>
                                    <td>VILLAHERMOSA</td>
                                     <td>507</td>
                                </tr>
                            </table>
                        </div>
                    </div>


                      <!-- _____BLOQUE 4_____ -->
                    <div class="headerBlq">
                        <p>Departamentos que no se veran modificados por esta query:</p>
                    </div>
                    <div class="bloque4">
                       
                        <div class="div_table">
                            <table>
                               
                                <tr>
                                    <td>Moldeo</td>
                                    
                                </tr>
                                <tr>
                                    <td>Molino</td>  
                                </tr>
                                <tr>
                                    <td>Vigueta</td>  
                                </tr>
                                <tr>
                                    <td>Bono Garantía</td>  
                                </tr>
                                <tr>
                                    <td>Insulpanel</td>  
                                </tr>
                                <tr>
                                    <td>Chofer Local / CEDI</td>  
                                </tr>
                                 <tr>
                                    <td>Almacén Local / CEDI</td>  
                                </tr>
                                
                            </table>
                            <p>Los <strong>Mantenimientos</strong> se verán afectados si reciben un departamento que si utilice la query. ejemplo: corte o bloquera.</p>
                        
                        </div>
                    </div>


                    

                </div>            
                </b-row>                                                     
                </b-col> 
               
              
            
        </b-row>      

      
</div>
  
 <b-modal id="modal-logout" centered hide-footer hide-header 
        body-class="p-0" dialog-class="px-5" content-class='border-0'>
            <div class="d-block text-center">
                <img :src="closeIcon" class="icon3 pt-5"><br>
                <p class="modalHeader pt-3">Eliminar Query</p>
                <p class="modalBody">¿Estás seguro que deseas eliminar esta versión?</p>
            </div>
            <div class="wrapper center">
                <b-button class="one mt-3 py-3 btnleft" @click="$bvModal.hide('modal-logout') , updateId()">Cancelar</b-button>
                <b-button class="two mt-3 btnright" @click="eliminarQuery()">Confirmar</b-button>
            </div>
 </b-modal>


  <b-modal id="modal-activar" centered hide-footer hide-header 
        body-class="p-0" dialog-class="px-5" content-class='border-0'>
            <div class="d-block text-center">
                <img :src="closeIcon" class="icon3 pt-5"><br>
                <p class="modalHeader pt-3">Activar Query</p>
                <p class="modalBody">¿Estás seguro que deseas activar esta versión?</p>
            </div>
            <div class="wrapper center">
                <b-button class="one mt-3 py-3 btnleft" @click="$bvModal.hide('modal-activar') , updateId()">Cancelar</b-button>
                <b-button class="two mt-3 btnright" @click="activarQuery()">Confirmar</b-button>
            </div>
 </b-modal>

   <b-modal id="modal-cambios" centered hide-footer hide-header 
        body-class="p-0" dialog-class="px-5" content-class='border-0'>
            <div class="d-block text-center">
               
                <p class="modalHeader pt-3">Cambios realizados:</p>
                <p class="modalBody">{{modalCambios}}</p>
            </div>
            <div class="wrapper center">
                <b-button class="one mt-3 py-3 " @click="$bvModal.hide('modal-cambios') , updateTextModal()">OK</b-button>
            </div>
 </b-modal>



</div>

   
</template>


<script>

import userService from '../services/user.service'
import { mapActions } from "vuex";
import i_notif from '../assets/icono_notificaciones.png'
import i_logout from '../assets/iconocerrar.png'
import moment  from 'moment'
export default {
    name: 'Query',
    
    data() {
        return {
            notifIcon: i_notif,
            closeIcon: i_logout,
            alert: 2,
            query:`nada`,
            status:'',
            msg:'',
            queryId:'',
            cambios:'',
            modalCambios:'',
        }
    },
   
    created() {
    
    this.getQuery('get_qry');

    this.getQuerys('get_allqrys')
    
  },


    computed: {
        
         dataquery(){
    
            return this.$store.getters['query/data']
            
        },
        allQuerys(){
        
           
           return   this.$store.getters['querys/data']
        },
        user() {
        return this.$store.getters['userService/getIdentity'];
        },
        
    },
    methods: {
         ...mapActions("query", ["getQuery"]),
         ...mapActions("querys", ["getQuerys"]),
         validateDia(){
             let  valid = true 
             let dia = moment().day()
             let hora = moment().hour()
            if(dia == 0 || dia == 6 ){ // jueves a domingo no se podra editar
                valid = false;
            } 
            if( dia == 1 && hora < 11 ){ // lunes antes de las 11 no se podra editar.
                valid = false;
            }
            if(dia == 5 && hora > 14){
                valid = false;
            }

             return valid
         },
        replace:function(query){
           return  query.replaceAll('fecha','${dia}')
            
        },
        mostrarCambios(cambios){
            this.modalCambios= cambios
        },
        updateTextModal(){
            this.modalCambios=''
        },
        setKey(queryId){
            this.queryId= queryId
        },
        updateId(){
            this.queryId= ''
        },
        eliminarQuery: async function(){
        if(this.validateDia()){
                let result = await this.$store.dispatch("query/deleteQuery",  {"id": this.queryId});
                if(result.status=='error'){
                    this.status = result.status
                    this.msg = result.message
                   this.delStatus()
                }else{
                    this.status = result.status
                    this.msg = result.message
                    this.delStatus()
                }
        }else{
                    this.status = 'error'
                    this.msg = 'Esta funcionalidad solo esta activa los lunes a partir de las 11 am al Miercoles a las 12 am.'
                    this.delStatus()
        }

         
        },
        activarQuery: async function(){
           //alert('activar ' + )
            if(this.validateDia()){
            let result = await this.$store.dispatch("query/changeQuery",  {"id": this.queryId});
                if(result.status=='error'){
                    this.status = result.status
                    this.msg = result.message
                   this.delStatus()
                }else{
                    this.status = result.status
                    this.msg = result.message
                    this.delStatus()
                }
            }else{
                 this.status = 'error'
                    this.msg = 'Esta funcionalidad solo esta activa los lunes a partir de las 11 am al viernes a las antes de las 2 pm.'
                    this.delStatus()
            }
        },
        editarQuery: async function(query, cambios){

            this.msg=''
            this.status =''



             let token = userService.getToken();
             let identity = userService.decode(token);
            let user = identity.name +'-'+ identity.num

            //VALIDAR QUE LA QUERY NO VENGA VACIA.
       

            if(user ==undefined || user =='' || user ==null){
                this.msg='Usuario no valido'
                this.status ='error'
               
              this.delStatus()
            }else if(query == '' || query == undefined || query == null ){
                this.msg='La query esta vacia.'
                this.status ='error'
             
              this.delStatus()
            }else if(cambios == '' || cambios == undefined || cambios == null ){
                this.msg='El campo de cambios es requerido para poder guardar la query.'
                this.status ='error'
             
              this.delStatus()
            }else{ 
                cambios = cambios.replaceAll("'",'')
                let result = await this.$store.dispatch("query/editQuery",  {data:query, user: user, cambios:cambios});
                if(result.status=='error'){
                    this.status = result.status
                    this.msg = result.message
                   this.delStatus()
                }else{
                    this.status = result.status
                    this.msg = result.message
                    this.delStatus()
                }
              
            }

            




            //
        },
       
        wait: function(){
            setTimeout(() => this.$router.go(), 500);
        },
         toAdmin: function () {
            this.$router.push("/").catch((err) => {});
         },


        refresh: function () {
            setTimeout(() => this.$router.go());
         },
        delStatus: function () {
            setTimeout(() => this.delMsgs(),1000);
            
            setTimeout(() => this.refresh(),500);
            
        },
        delMsgs: function(){
            this.status=""
            this.msg=""
        },
            


    },
    filters:{
        rand: (value) => {
            if (!value) return '';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        stringify: (value) => {
            if(!value) return '0';
            if (typeof value == 'number'){
                return value.toString();
            }
        },
        cap: (value) => {
            if (!value) return '';
            value = value.toString();
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i; 
            for (i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            return nameCap;
        }
    }
}
</script>
<style scoped>

/*********** ESTILOS INSTRUCCIONES PARA MODIFICAR QUERY ***************/
.form_cambios{
    display: grid;
    margin-top: 2vw;
}

.form_cambios textarea{
    width: 60vw;
}

#historial_querys{
    width: 62vw;
}

#historial_querys h3{
    color:#005cc3;
    font-size: 2vw;
    font-weight: 900;
}
#historial_querys p{
    margin-bottom: .2vw !important;
    font-size: .9vw;
    width: 54vw;
}
.text_grey{
    color:grey;
}



.msg_success{
    height: 2vw;
    width: 59vw;
    margin-left: 0.7vw;
    margin-top: 1vw;
    background-color: rgb(0 194 104);
    color: #fff;
    text-align: -webkit-center;
    border-radius: 5px;
    font-size: 1vw;
    padding-top: 0.3vw;
}
.msg_alert{
    height: 2vw;
    width: 59vw;
    margin-left: 0.7vw;
    margin-top: 1vw;
    background-color: #fd832d;
    color: #fff;
    text-align: -webkit-center;
    border-radius: 5px;
    font-size: 1vw;
    padding-top: 0.3vw;
}
.msg_error{
    height: 2vw;
    width: 59vw;
    margin-left: 0.7vw;
    margin-top: 1vw;
    background-color: rgb(231 54 41);
    color: #fff;
    text-align: -webkit-center;
    border-radius: 5px;
    font-size: 1vw;
    padding-top: 0.3vw;
}

.Tabla{
    padding-top: 2vw; 
}

.headerBlq{
    background-color: #005cc3;
    border-top-left-radius: 1.5vw;
    border-top-right-radius: 1.5vw;
    height: 2vw;
    margin-bottom: .5vw;
}
.headerBlq p{
    color: white;
    font-size: 1vw;
    margin-bottom: 0vw;
    padding-top: .3vw;
    text-align: center;
}
.labelQueryTA{
    background-color: #ffc107;
    border-top-left-radius: 1.5vw;
    border-top-right-radius: 1.5vw;
    height: 3vw;
    width: 60vw;
    padding-top: 0.5vw;
    text-align: center;
    color: white !important;
}
.tabla_yellow{
    background-color: #ffc107;
    border-top-left-radius: 1.5vw;
    border-top-right-radius: 1.5vw;
    height: 3vw;
    width: 60vw;
    margin-bottom: 1vw;
}
.ty_text{    
    display: flex;
    margin-left: 6.2vw;
}

.ty_text p{
   
     text-align: center !important;
}
.tabla_yellow p{
    color: white;
    margin-right: .5vw;
    margin-top: .7vw;
    font-size: 1vw;    
}#elim_text1{   
    width: 4vw;
   
}#elim_text2{    
     width: 10vw;
      margin-left: 2vw ;
}#elim_text3{    
     margin-left: 3vw ;
     width: 12vw;
     
}#elim_text4{    
        margin-left: 2vw;
    width: 4vw;
     
}#elim_text5{    
     margin-left: 2vw ;
     width: 3vw;
}#elim_text6{
       margin-left: 2vw;
    width: 4vw;
     
}


#sec_query .col{
    max-width: 67%;    
}

.div_content{
    
}
.tabla_content{
    background-color: #e4e4e4;
    width: 60vw;
    height: auto;
    text-align: -webkit-center;
    padding: 1vw;
    padding-bottom: 2vw;
    border-bottom-left-radius: 2vw;
    border-bottom-right-radius: 2vw;
}
.registros{
    display: flex;
    background-color: #fff;
    width: 55vw;
    height: 4vw;
    padding-top: 1.3vw;
    margin-top: 1vw;
    border-radius: 20px;
}.registros p{    
    background-color: #fff;
    margin-left: 2vw;
    font-size: 1vw;
}.square1{
    margin-left: 1vw;
    background-color: rgb(0, 194, 144);
}

.activa{
    color: rgb(0, 194, 144);
}

.activar:hover{
    color: rgb(0, 194, 144);
    cursor: pointer;
}#t1{
    width: 4vw;
    transition: all 300;
}#t1:hover{
    color:#005cc3;
    font-weight: 900;
}#t2{
    width: 10vw;
}#t3{
    width: 16vw;
}#t4{
    width: 1vw;
    margin-right: 2vw;
}
#equis{
    margin-left: 4vw;
    cursor: pointer;
    transition: all 300ms;
}

#equis:hover{
    color: rgb(231 54 41);
}

.text_title{
    font-weight: 600 !important;
    font-size: .8vw !important;
    text-align: center;
     padding-bottom: 0.5vw;
    border-bottom: 0.1vw solid #b1aeae;
}

.bloque0{
    width: 30vw;
    background: #e4e4e4;
    margin-top: 0vw;
    padding: 1vw;
    margin-bottom: 1vw;
    border-radius: 0vw 0vw 1vw 1vw;
}

    .bloque0 p{
        flex-flow: nowrap;
        font-size: .7vw;    
        font-family: sans-serif;
        color: black;
    }

.bloque1{
    background: #e4e4e4;
    border-radius: 0vw 0vw 1vw 1vw;
    padding: 1vw;
    margin-bottom: 1vw;
    width: 30vw;
}
    .bloque1 p{
        flex-flow: nowrap;
        font-size: .7vw;    
        font-family: sans-serif;
        color: black;
    }


.bloque2{
    width: 30vw;
    height: auto;
 background: #e4e4e4;
    border-radius: 0vw 0vw 1vw 1vw;
    padding: 1vw;
    margin-bottom: 1vw;
}
    .bloque2 p{
        flex-flow: nowrap;
        font-size: .7vw;    
        font-family: sans-serif;
        font-weight: normal;
    }
    .bloque2 pre{
        font-size: .62vw;
        font-weight: bold;
        font-family: sans-serif;
    }
    #b1_t6{
        font-size: .655vw;
        color: black;
    }
    #b1_t7{
        font-size: .72vw;
        color: black;
    }


.bloque3{
    width: 30vw;
    height: auto;
   background: #e4e4e4;
    border-radius: 0vw 0vw 1vw 1vw;
    padding: 1vw;
    margin-bottom: 1vw;
}
    .bloque3 p{
        flex-flow: nowrap;
        font-size: .58vw;  
        font-family: sans-serif;  
    }
    .bloque3 pre{
        font-size: .58vw;
        font-weight: bold;
        font-family: sans-serif;
    }
    #b3_titulo{
        font-size: .7vw;
    }
    #b3_text3{
        font-size: .7vw;
        color: black;
    }
    #b3_text5{
        font-size: .64vw;
        color: black;
    }



.bloque4{
    width: 30vw;
    height: auto;
    background: #e4e4e4;
    border-radius: 0vw 0vw 1vw 1vw;
    padding: 1vw;
    margin-bottom: 1vw;
}
    .bloque4 p{
        flex-flow: nowrap;
        font-size: .8vw;    
        font-family: sans-serif;
    }
.div_table{
    text-align: -webkit-center;
    margin-bottom: 1vw;
}
    .bloque4 table{
        width: 23vw;
    }
        .bloque4 tr{
            color: rgb(51 51 58);
        }
        .bloque4 tr:nth-child(even){
            background: rgb(189 189 189);
            font-family: sans-serif;
        }.bloque4 td:first-child{    
            text-align: left;
            padding-left: .5vw;
            font-family: sans-serif;
        }
        .bloque4 th{
            border-top: 1px solid rgb(51 51 58);
            border-bottom: 1px solid rgb(51 51 58);
            width: 20%;
            font-family: sans-serif;
        }


.bloque5{
    width: 30vw;
    background: #e4e4e4;
    border-radius: 0vw 0vw 1vw 1vw;
    padding: 1vw;
    margin-bottom: 1vw;
}
    .bloque5 pre{
        flex-flow: nowrap;
        font-size: .7vw;    
        font-family: sans-serif;
        color: black;
    }









.text_blue{
    color: blue;
}.text_red{
    color: red;
}.text_cafe{
    color: rgb(95, 49, 49);
}.text_green{
    color: green;
}









/*******************************************************************/

/** MODAL**/



button.logout{
    border-radius: 20px;
    border-color: white;
    text-transform: uppercase;
    font-size: 11px;
    padding: .3rem 1.5rem;
}
button.logout:hover{
    background-color: #3b63c9;
    border-color: #3b63c9;
}
button.logout:focus{
    outline: none;
}
.icon2{
    max-width: .9rem;
    cursor: pointer;
}
.icon3{
    max-width: 4rem;
}
.nbadge{
    border-radius: 50%;
    font-size: 10px;
    position: absolute;
}
p.modalHeader{    
    color: #fd832d;
    text-transform: uppercase;
    font-family: 'FuturaPTDemi';
}
p.modalBody{
    font-size: 17px;
    font-weight: lighter;
    font-family: 'FuturaPTMedium';
    color: #838383;
}
.wrapper {
    display: grid;
    grid-template-columns: auto;
    grid-auto-rows: auto;
}
.one {
    grid-column: 1;
    grid-row: 4;
    font-family: 'FuturaPTMedium';
    background-color: #f3f3f3;
    color: #838383;
    border-color: #f3f3f3;  
}
.two {
    grid-column: 2;
    grid-row: 4;
    font-family: 'FuturaPTMedium';
    background-color: #fd832d;
    border-color: #fd832d;  
}
 #modal-logout > .modal-dialog > .modal-content{
    border-radius: 24px;
}

 #modal-activar > .modal-dialog > .modal-content{
    border-radius: 24px;
}
.btnleft{
    border-radius: 0px;
    border-bottom-left-radius: 20px;
}
.btnright{
    border-radius: 0px;
    border-bottom-right-radius: 20px;
}






/***/
.active {
     background-color: #fe9136 !important;
    border-color: #fe9136 !important;
}

.square1{
    height: 10.5px;
    width: 10.5px;
    margin-top: 3.4px;
}
.icon{
    max-width: 1rem;
    cursor: pointer;
}
input#inputB0,
input#inputDS,
input#inputE,
input#inputM{
    font-family: 'FuturaPTMedium';
    border-color: #d2d6dd;
    min-width: 80px;
    border-radius: 7px;
    color: #fd832d
}
label{
    font-family: 'FuturaPTMedium';
    color: #838383 !important;
    font-size: 95% !important;
    font-weight: 100 !important;
}
.stylingTitle{
    font-family: 'FuturaPTMedium';
    color: #bcbcbc;
    font-size: 1rem;
}
.labelB0{
    margin-right: 6rem;
}
.labelDS{
    margin-right: 4.5rem;
}
::placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
:-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
::-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.adminPila{
    min-height: 15rem;
    min-width: 100%;
}

.adminPila2{
    min-height: 10rem;
    min-width: 100%;
}
ul{
    padding: 0;
    padding-left: 1rem;
    font-size: small;
}
.blue {
    background-color: #4d78e7;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
    color: white;
}
.blue:hover{
    background-color: #3b63c9;
}
.saved{
    background-color: white;
    border: 1px solid #3b63c9;
    color: #3b63c9;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
}
li >>> a {
    color: #838383;
}
@media (max-width: 420px) { 
    div.inactive-class img{
        margin-left: -2rem;
    }
    div.inactive-class h5{
        margin-right:2rem;
        font-size:.9rem;
    }
}
@media (max-width: 527px) { 
    div.inactive-class h5{
        margin-right:2rem;
    }
}
</style>